import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginModule } from './pages/login/login.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpService } from './wrappers/Http';
import { HomeModule } from './pages/home/home.module';
import { SportServicesService } from './services/sport-service/sport-services.service';
import { HelperFunctions } from './services/helper-functions';
import { PipeModule } from './pipes/pipe.module';
import { MessageService } from 'primeng/api';
import { AddRuleHelperFunctions } from './services/add-rule-helper-functions.service';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { ConfigService } from './services/config.service';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { LocaleService } from './services/locale/locale.service';

// Register locale data
registerLocaleData(localeEn);
registerLocaleData(localeEs);

export function localeFactory(localeService: LocaleService) {
  return () => localeService.locale()
}

export function configFactory(config: ConfigService) {
  return () => config.loadConfigs();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LoginModule,
    HttpClientModule,
    RichTextEditorAllModule,
    ToastModule,
    PipeModule,
    HomeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: localeFactory,
      deps: [LocaleService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [ConfigService],
      multi: true
    },
    HttpService, ConfigService, SportServicesService, AddRuleHelperFunctions, HelperFunctions, MessageService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}
